Ext.define('SA.view.SessionReplacedPopup', {
    alias: 'widget.session-replaced-popup',
    extend: 'SA.view.SimpleContainer',

    autoShow: true,
    cls: 'sa-session-replaced-popup',
    floating: true,
    modal: true,
    plugins: 'sa-viewport-constrained-auto-center',

    items: [
        {
            xtype: 'simple-container',
            cls: 'sa-session-replaced-popup-header',
            itemId: 'header',

            items: [
                {
                    xtype: 'component',
                    cls: 'sa-session-replaced-popup-title',
                    html: 'Session Expired'
                }
            ]
        }, {
            xtype: 'component',
            cls: 'sa-session-replaced-popup-body',
            itemId: 'body',

            html: [
                '<svg class="sa-session-replaced-popup-info-svg"><use href="#sa-icon-map-info"></use></svg>',
                '<div>',
                    'You appear to have logged in to SimplyAnalytics from another tab.<br><br>',
                    'Please close this tab and continue to use SimplyAnalytics from the new tab.',
                '</div>'
            ]
        }
    ]
});